<template>
  <v-container fluid>
    <v-stepper v-model="step" class="elevation-0" style="background-color: rgba(0,0,0,0) !important;" alt-labels>
      <v-stepper-header class="justify-center elevation-0">
        <v-stepper-step :complete="step > 1" step="1">{{ $t('steps.evaluation') }}</v-stepper-step>
        <v-stepper-step :complete="step > 2" step="2">{{ $t('steps.account') }}</v-stepper-step>
        <v-stepper-step :complete="step > 3" step="3">{{ $t('steps.confirmation') }}</v-stepper-step>
      </v-stepper-header>
      <v-stepper-items class="mt-n5">
        <v-stepper-content step="1">
          <v-row style="min-height: 70vh" align="center" justify="center">
            <v-col cols="3" class="text-center">
              <h2 class="mb-5">{{ $t('vendor.title') }}</h2>
              <v-btn v-bind:key="i" v-for="(vendor, i) in vendors" style="width: auto; min-width: 51%" elevation="0"
                     :class="(vendorSelected !== null && vendor.id === vendorSelected.id)? 'btn-selected mb-3' : 'btn-not-selected mb-3'" @click="vendorChanged(vendor)">{{ vendor.name }}</v-btn>
            </v-col>
            <v-divider vertical/>
            <v-col cols="8">
              <VendorEvaluationsTable v-if="vendorSelected !== null" :vendor="vendorSelected" :vendor-evaluations="vendorEvaluations" @evaluationSelection="evaluationChanged"/>
            </v-col>
          </v-row>
          <v-row align="center" justify="center">
            <v-btn class="mr-5" @click="back">{{ $t('btnBackMarket') }}</v-btn>
            <v-btn :disabled="evaluationSelected === null" @click="next">{{ $t('btnNextAccount') }}</v-btn>
          </v-row>
        </v-stepper-content>
        <v-stepper-content step="2">
          <v-row style="min-height: 70vh" align="center" justify="center">
            <v-col cols="10">
              <v-row align="center" justify="center">
                <h2 class="mb-5">{{ $t('account.title') }}</h2>
              </v-row>
              <v-row align="center" justify="center">
                <v-data-table v-if="verifiedAccounts.length > 0" v-model="accountsFromTable" @input="accountChanged" @change="accountChanged" style="background-color: transparent" single-select show-select :items="verifiedAccounts" :headers="accountTableHeaders">
                  <template v-slot:item.automated="{ item }">
                    <img v-if="item.automated" src="@/assets/icons/AutoSync.svg" alt="AutoSync Icon" class="mr-1" style="width: 16px; height: 16px; color: green;" />
                  </template>
                  <template v-slot:item.verified="{ item }"> 
                    <img v-if="item.verified" src="@/assets/icons/Audited.svg" alt="Audited Icon" class="mr-1" style="width: 16px; height: 16px; color: blue;" />
                  </template>
                </v-data-table>
                <v-col v-else>
                  <v-icon class="d-flex align-center justify-center" x-large>fa-regular fa-grin-beam-sweat</v-icon>
                  <h3 class="text-center my-3">{{ $t('notVerified.title') }}</h3>
                  <div class="d-flex align-center justify-center">
                    <v-btn class="special-button text-center mb-0" @click="seeHowToVerify">{{ $t('notVerified.btnSeeHow') }}</v-btn>
                  </div>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-row align="center" justify="center">
            <v-btn class="mr-5" @click="back">{{ $t('btnBackEvaluation') }}</v-btn>
            <v-btn :disabled="accountSelected === null" @click="next">{{ $t('btnNextConfirmation') }}</v-btn>
          </v-row>
        </v-stepper-content>
        <v-stepper-content v-if="evaluationSelected !== null && vendorSelected !== null && accountSelected !== null" step="3">
          <v-row style="min-height: 70vh" align="center" justify="center">
            <v-col cols="10">
              <v-row align="center" justify="center">
                <h2 class="mb-5">{{ $t('confirmation.title') }}</h2>
              </v-row>
              <v-row align="center" justify="center">
                <v-col cols="5">
                  <h3 :class="`${(i < confirmationData.length)? 'mb-3' : ''} ${(currentConfirmationItem === confirmationItem.item)? 'black-content' : 'gray-content'}`"
                      style="white-space: nowrap" v-bind:key="i" v-for="(confirmationItem, i) in confirmationData">
                    <v-icon :class="`mr-2 mt-n1 ${(currentConfirmationItem === confirmationItem.item)? 'black-content' : 'gray-content'}`">{{ getConfirmationItemIcon(confirmationItem.item) }}</v-icon>
                    {{ $t(`confirmation.${confirmationItem.item}Selected`, { firstValue: confirmationItem.firstValue, secondValue: confirmationItem.secondValue }) }}
                    <v-icon v-if="confirmationItem.confirmed" class="ml-1 mt-n1" color="primary" x-small>fa-check-circle</v-icon>
                    <v-chip class="ml-1 mt-n1" color="primary" v-if="currentConfirmationItem === confirmationItem.item"
                            @click="confirmItem(confirmationItem.item)" small>{{ $t('confirmation.btnToConfirm') }}</v-chip>
                  </h3>

                  <!--h3><v-icon class="mr-2 mt-n1">{{ getConfirmationItemIcon('Market') }}</v-icon>
                    {{ $t('confirmation.marketSelected', {market: market}) }}</h3>
                  <h3><v-icon class="mr-2 mt-n1">{{ getConfirmationItemIcon('Account') }}</v-icon>
                    {{ $t('confirmation.accountSelected', { broker: accountSelected.broker.name, identifier: accountSelected.identifier}) }}</h3>
                  <h3><v-icon class="mr-2 mt-n1">{{ getConfirmationItemIcon('Evaluation') }}</v-icon>
                    {{ $t('confirmation.evaluationSelected', {evaluation: evaluationSelected.name, vendor: vendorSelected.name}) }}</h3>
                  <h3><v-icon class="mr-2 mt-n1">{{ getConfirmationItemIcon('Balance') }}</v-icon>
                    {{ $t('confirmation.balanceSelected', {balance: new Intl.NumberFormat().format(evaluationSelected.initialBalance)}) }}</h3>
                  <h3><v-icon class="mr-2 mt-n1">{{ getConfirmationItemIcon('Target') }}</v-icon>
                    {{ $t('confirmation.targetSelected', {target: new Intl.NumberFormat().format(evaluationSelected.target)}) }}</h3!-->
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-row align="center" justify="center">
            <v-btn class="mr-5" @click="back">{{ $t('btnBackAccount') }}</v-btn>
            <v-btn class="btn-selected" :disabled="!allItemsConfirmed" @click="next"><v-icon class="mr-2 mx-auto" x-small>fa-check</v-icon>{{ $t('btnFinish') }}</v-btn>
          </v-row>
        </v-stepper-content>
      </v-stepper-items>
    </v-stepper>

    <v-overlay :dark="false" v-model="overlayProFeature">
      <UpgradeToPro :message="messageCTAPro"/>
    </v-overlay>
  </v-container>
</template>

<script>
import Repository from '../../../../repositories/funding';
import VendorEvaluationsTable from "@/views/Funding/Simulation/components/VendorEvaluationsTable";
import UpgradeToPro from "@/components/UpgradeToPro";

export default {
  name: "TestOnBoarding",
  components: {UpgradeToPro, VendorEvaluationsTable},
  props: {
    market: String,
    firstCreated: Boolean,
  },
  data() {
    return {
      //Global
      overlayProFeature: false,
      messageCTAPro: this.$t('messageCTAPro'),
      step: 1,

      // Step 1
      allEvaluations: [],
      vendors: [],
      vendorEvaluations: [],
      vendorSelected: null,
      evaluationSelected: null,

      // Step 2
      verifiedAccounts: [],
      accountTableHeaders: [
        { text: this.$t('brokerTable.brokerName'), value: 'broker.name', sortable: false, align: 'left' },
        { text: this.$t('brokerTable.identifier'), value: 'identifier', sortable: false, align: 'left' },
        { text: this.$t('brokerTable.type'), value: 'type', sortable: false, align: 'left' },
        { text: this.$t('brokerTable.currency'), value: 'currency', sortable: false, align: 'left' },
        { text: this.$t('brokerTable.automated'), value: 'automated', sortable: false, align: 'left' },
        { text: this.$t('brokerTable.verified'), value: 'verified', sortable: false, align: 'left' },
      ],
      accountSelected: null,
      accountsFromTable: [],

      // Step 3
      currentConfirmationItem: 'market',
      confirmationData: [],

      // Validation
      validFirst: false,
      validSecond: false,
    };
  },
  computed: {
    allItemsConfirmed() {
      return this.confirmationData.filter((item) => item.confirmed === true).length === this.confirmationData.length;
    },
  },
  mounted() {
    this.validateMarket();
    this.setDefaults();
  },
  methods: {
    validateMarket() {
      if(this.market === undefined)
        this.$router.push({ name: 'funding-simulation-home' });
    },
    setDefaults() {
      Repository.allFundingEvaluationsByMarket(this.market).then((response) => {
        if(response.status < 400) {
          this.allEvaluations = response.data;
          this.vendorsFilter();
        }
      });
      this.verifiedAccounts = this.$store.state.user.brokerAccounts.filter((brokerAccount) => brokerAccount.verified);
    },
    next() {
      if(this.step === 3)
        this.createFundingTest();
      else if(this.step === 2) {
        this.processConfirmationData();
        this.step++;
      }
      else
        this.step++;
    },
    back() {
      if(this.step === 1)
        this.$router.push({ name: 'funding-simulation-home' });
      else
        this.step--;
    },
    vendorsFilter() {
      let map = {};
      this.vendors = [];

      this.allEvaluations.forEach((fullEvaluation) => {
        if(!(fullEvaluation.evaluation.fundingVendor.id in map))
          map[fullEvaluation.evaluation.fundingVendor.id] = fullEvaluation.evaluation.fundingVendor;
      });

      for(let vendorId in map)
        this.vendors.push(map[vendorId]);
    },
    vendorChanged(vendor) {
      if(this.vendorSelected === null || this.vendorSelected.id !== vendor.id) {
        this.vendorSelected = vendor;
        this.vendorEvaluations = this.allEvaluations.filter((fullEvaluation) => fullEvaluation.evaluation.fundingVendor.id === this.vendorSelected.id);
        this.evaluationSelected = null;
      }
    },
    evaluationChanged(evaluation) {
      this.evaluationSelected = evaluation;
    },
    accountChanged() {
      if(this.accountsFromTable.length > 0)
        this.accountSelected = this.accountsFromTable[0];
      else
        this.accountSelected = null;
    },
    getConfirmationItemIcon(item) {
      switch (item) {
        case 'market':
          return 'fa-exchange-alt';
        case 'account':
          return 'fa-suitcase';
        case 'evaluation':
          return 'fa-swatchbook';
        case 'balance':
          return 'fa-coins';
        case 'target':
          return 'fa-money-bill-wave';
      }
    },
    processConfirmationData() {
      //this.overlayProFeature = (!this.$store.state.user.isPro && this.firstCreated); // Just for February 2023 Campaign
      this.currentConfirmationItem = 'market';
      this.confirmationData = [
        { item: 'market', firstValue: this.market, secondValue: '', confirmed: false, },
        { item: 'account', firstValue: this.accountSelected.identifier, secondValue: this.accountSelected.broker.name, confirmed: false, },
        { item: 'evaluation', firstValue: this.evaluationSelected.name, secondValue: this.vendorSelected.name, confirmed: false, },
        { item: 'balance', firstValue: new Intl.NumberFormat().format(this.evaluationSelected.initialBalance), secondValue: '', confirmed: false, },
        { item: 'target', firstValue: new Intl.NumberFormat().format(this.evaluationSelected.target), secondValue: '', confirmed: false, },
      ];
    },
    confirmItem(item) {
      let index = this.confirmationData.findIndex((itemData) => itemData.item === item);
      this.confirmationData[index].confirmed = true;
      this.currentConfirmationItem = (index + 1 < this.confirmationData.length)? this.confirmationData[index + 1].item : '';
    },
    createFundingTest() {
      let currentCycleEndTime = new Date();
      let additionalMonths = this.evaluationSelected.periodInDays / 30;
      currentCycleEndTime = new Date(currentCycleEndTime.setMonth(currentCycleEndTime.getMonth() + additionalMonths));

      let fundingTest = {
        user: { id: this.$store.state.user.id },
        createdAt: new Date(),
        currentCycleStartTime: new Date(),
        currentCycleEndTime: currentCycleEndTime,
        participantStatus: 'ACTIVE',
        currentProfit: 0,
        currentSpending: Number(this.evaluationSelected.periodCost),
        fundingEvaluation: { id: this.evaluationSelected.id },
        brokerAccount: { id: this.accountSelected.id },
      };

      Repository.createFundingTest(fundingTest).then((response) => {
        if(response.status < 400) {
          alert(this.$t('alerts.created'));
          this.$router.push({ name: 'funding-simulation-summary', params: { testId: response.data.id }});
        }
        else
          alert(this.$t('alerts.error'));
      });
    },
    seeHowToVerify() {
      window.open((this.$i18n.locale === 'en')? 'https://youtu.be/3CWrhER2kOQ' : 'https://www.youtube.com/watch?v=uLZZKE6z530');
    }
  }
}
</script>



<style lang="scss" scoped>
@import "src/global";

.gray-content {
  color: $border-color;
}

.black-content {
  color: $black-color;
}

.btn-selected {
  color: $black-color !important;
  background-color: $primary-color !important;
  border: 1px solid $border-color !important;
}

.btn-not-selected {
  color: $black-color !important;
  background-color: $white-color !important;
  border: 1px solid $border-color !important;
}

.special-button {
  color: $white-color !important;
  background-color: $black-color !important;
  border: 1px solid $border-color !important;
}
</style>
